export default __webpack_public_path__ + "static/media/pt-20.c61c3121.svg";